import axiosInstance from "../Instance/axiosInstance";
import { Uom } from "./uom.types";

// ✅ Get All
export const getUOM = async (): Promise<Uom[]> => {
  const { data } = await axiosInstance.get<{ data: Uom[] }>(
    "/admin/get_All_UOM"
  );
  return data.data;
};

// ✅ Create
export const createUom = async (
  name: string,
  description: string
): Promise<Uom> => {
  const { data } = await axiosInstance.post<{ data: Uom }>(
    "/admin/create_UOM",
    { name, description }
  );
  return data.data;
};

// ✅ Get By ID
export const getUomById = async (id: number): Promise<Uom> => {
  const { data } = await axiosInstance.get<{ data: Uom }>(
    `/admin/get_UOM/${id}`
  );
  return data.data;
};

// ✅ Update
export const updateUomApi = async (
  id: number,
  payload: { name: string; description: string; status: string }
): Promise<void> => {
  await axiosInstance.put(`/admin/update_UOM/${id}`, payload);
};

// ✅ Delete (Soft delete)
export const deleteUomApi = async (id: number): Promise<void> => {
  await axiosInstance.delete(`/admin/delete_UOM/${id}`);
};

// ✅ Update Status
export const updateUomStatusApi = async (
  id: number,
  payload: { status: string }
): Promise<void> => {
  await axiosInstance.put(`/admin/update_UOM_status/${id}`, payload);
};


export const updateArticleStatusApi = async (id: number): Promise<void> => {
  await axiosInstance.put(`/admin/article/status/${id}`);
};